import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Form, Pagination } from "react-bootstrap";
import {
  fetchUsers,
  fetchUserSubscriptions,
  fetchSubscriptions,
  subscribeUser,
} from "../../utilities/AdminUtilities";
function UserDetails() {
  const [users, setUsers] = useState([]);
  const [limit, setLimit] = useState(20);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showSubscribeModal, setShowSubscribeModal] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);
  const [searchEmail, setSearchEmail] = useState("");
  const [searchFirstName, setSearchFirstName] = useState("");
  const [searchLastName, setSearchLastName] = useState("");
  const [searchPhoneNumber, setSearchPhoneNumber] = useState("");

  const [userSubscriptionIds, setUserSubscriptionIds] = useState(new Set([]));

  useEffect(() => {
    fetchSubscriptions(setSubscriptions);
  }, []);
  useEffect(() => {
    fetchUsers(
      limit,
      offset,
      searchEmail,
      searchFirstName,
      searchLastName,
      searchPhoneNumber,
      setUsers
    );
  }, [
    searchEmail,
    searchFirstName,
    searchLastName,
    searchPhoneNumber,
    currentPage,
  ]); //

  const handleRowClick = (user) => {
    setSelectedUser(user);
  };

  const handleSubscribeClick = (user) => {
    fetchUserSubscriptions(user.id, setUserSubscriptionIds);
    setSelectedUser(user);
    setShowSubscribeModal(true);
  };

  return (
    <>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Phone Number</th>
            <th>Email</th>
            <th>ID</th>
            <th>Organization</th>
            <th>Role</th>

            <th>Action</th>
          </tr>
          <tr>
            <th>
              <Form.Control
                size="sm"
                type="text"
                placeholder="Search by First Name"
                value={searchFirstName}
                onChange={(e) => setSearchFirstName(e.target.value)}
              />
            </th>
            <th>
              <Form.Control
                size="sm"
                type="text"
                placeholder="Search by Last Name"
                value={searchLastName}
                onChange={(e) => setSearchLastName(e.target.value)}
              />
            </th>
            <th>
              <Form.Control
                size="sm"
                type="text"
                placeholder="Search by Phone"
                value={searchPhoneNumber}
                onChange={(e) => setSearchPhoneNumber(e.target.value)}
              />
            </th>
            <th>
              <Form.Control
                size="sm"
                type="text"
                placeholder="Search by Email"
                value={searchEmail}
                onChange={(e) => setSearchEmail(e.target.value)}
              />
            </th>
            {/* Empty th elements for remaining columns */}
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => (
            <tr key={user.id} onClick={() => handleRowClick(user)}>
              <td>{user.first_name || "NA"}</td>
              <td>{user.last_name || "NA"}</td>
              <td>{user.phone_number || "NA"}</td>
              <td>{user.email || "NA"}</td>
              <td>{user.id || "NA"}</td>
              <td>{user.organiztaion || "NA"}</td>
              <td>{user.role || "NA"}</td>
              <td>
                <Button
                  variant="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSubscribeClick(user);
                  }}
                >
                  Subscribe
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Pagination>{/* Add Pagination logic here */}</Pagination>

      <Modal
        show={showSubscribeModal}
        onHide={() => setShowSubscribeModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Subscribe User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedUser && (
            <p>
              Subscribing {selectedUser.name} (ID: {selectedUser.id})
            </p>
          )}
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Name</th>
                <th>ID</th>
                <th>Details</th>
                <th>Validity</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.map((subscription) => (
                <tr key={subscription.id}>
                  <td>{subscription.subscription_name}</td>
                  <td>{subscription.id}</td>
                  <td>{subscription.details}</td>
                  <td>{subscription.validity}</td>
                  <td>
                    <Button
                      onClick={() =>
                        subscribeUser(
                          subscription,
                          selectedUser,
                          setShowSubscribeModal
                        )
                      }
                      disabled={userSubscriptionIds.has(subscription.id)}
                    >
                      Subscribe
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default UserDetails;
